<div #printContent id="printContent">
  <wf-district-report-container [reportTitle]="'Usage Detail'" [loadError]="loadError" (onPrint)="printReport()">
    <div report-filter *ngIf="!shouldShowSchools || currentUser?.isFILUser()">
      <div class="print-hide">
        <wf-school-teacher-filter
          [error]="schoolFilterError"
          [districts]="districts"
          [schools]="schools"
          [teachers]="teachers"
          [showTeacher]="false"
          (filterChangeEvent)="filterSchoolTeacher($event)"
        ></wf-school-teacher-filter>
      </div>
    </div>

    <div [ngClass]="{ 'disabled-report' : schoolFilterError }"></div>
    <div class="district-report-content usage-report">
      <div *ngIf="!areSessionsForAcademicYear" class="alert message alert-warning">There have not been any active sessions yet for the current academic year</div>
      <div class="district-report-row" style="margin-top: 12px;">
        <div class="district-report-column width-25">
          <div class="usage-report-card print-hide" id="district-report-school-guidance">
            <div class="card-title">School Guidance</div>
            <div class="card-body stacked">
              <div class="section">
                <div class="icon-col">
                  <fa-icon [icon]="magnifyingGlassIcon" size="xl"></fa-icon>
                </div>
                <div class="text-col">
                  <div class="title">Usage Trend Graph</div>
                  <div class="card-divider"></div>
                  <div class="description-text">
                    <p>
                      Watch this graph to determine student usage trends from week to week. The goal for average weekly usage is 60-80 minutes.
                      This usage provides the best results.
                    </p>
                  </div>
                </div>
              </div>
              <div class="section">
                <div class="icon-col">
                  <fa-icon [icon]="magnifyingGlassIcon" size="xl"></fa-icon>
                </div>
                <div class="text-col">
                  <div class="title">School Engagement</div>
                  <div class="card-divider"></div>
                  <div class="description-text">
                    <p>Use this section to see the number of enrolled students and view the percentage of schools hitting their minimum weekly time goal.</p>
                  </div>
                </div>
              </div>
              <div class="section">
                <div class="icon-col">
                  <fa-icon [icon]="magnifyingGlassIcon" size="xl"></fa-icon>
                </div>
                <div class="text-col">
                  <div class="title">Teacher Engagement</div>
                  <div class="card-divider"></div>
                  <div class="description-text">
                    <p>
                      View individual teachers to determine the number of teacher logins, the % of students hitting the weekly time goal,
                      and % of students hitting the weekly units goal. We aim for teachers to log in 2-3 times per week to monitor student data.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="district-report-column width-75">
          <div class="district-report-panel" id="district-report-usage-trend">
            <div class="title">Usage Trend</div>
            <div id="usage-trend-chart" class="print-hide">
              <canvas baseChart
                      #usageTrendChart
                      class="chart chart-line"
                      id="usage-chart"
                      [data]="trendData"
                      [options]="trendOpts"
                      [type]="trendType"
                      [plugins]="chartPlugins"></canvas>
            </div>
            <img id="usage-chart-img" class="chart-img" #usageTrendImg/>
          </div>
        </div>
      </div>
      <div class="district-report-content-container">
        <div class="district-report-row split-flex page-break-after">
          <div class="district-report-column width-25">
            <div class="usage-stat-card" id="enrollment-numbers">
              <div class="title-section">
                <div class="title">Enrollment</div>
                <div class="icon-col print-hide">
                  <fa-icon [icon]="enrollmentIcon" size="2xl"></fa-icon>
                </div>
              </div>
              <div class="card-divider"></div>
              <div class="stat-section">
                <div class="stat-value">{{ enrolled }}</div>
                <div class="stat-label">Students Enrolled</div>
              </div>
            </div>
          </div>
          <div class="district-report-column width-75 right-text align-self-end">
            <div id="loginDateRange" class="print-hide">
              <label class="accent-text">Login date range</label>
              <select [(ngModel)]="dateRange" (change)="loadRangeData()">
                <option *ngFor="let range of dateRanges" [ngValue]="range">{{ range.rangeDisplay }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="district-report-row page-break-after" *ngIf="shouldShowSchools">
          <div class="district-report-column width-100">
            <wf-report-aggregate-panel [cols]="schoolCols"
                                      [data]="schoolAggregateData()"
                                      [showTable]="showSchoolTable"
                                      (sortTableEvent)="sortSchoolTable($event)">
              <div class="engagement-table" header>
                <div class="title split-flex">
                  <div style="display: flex ; column-gap: 20px ; align-items: center ;">
                    <span>School Engagement</span>
                    <span class="display-toggle print-hide" (click)="toggleSchoolTableSwitch()">{{ schoolTableSwitch }}</span>
                  </div>
                  <div class="dates-subtitle">Dates: {{ dateRange.startDisplay }} to {{ dateRange.endDisplay }}</div>
                </div>
                <div class="aggregate-stat-header-card school">
                  <div class="stat-title">{{ numSchoolsMeetingStudentMinWeeklyTimeGoalThreshold() }} of {{ schoolAggregateData().length }} schools</div>
                  <div class="stat-subtitle">had {{ studentPercentThresholdForMinWeeklyTimeGoal() }}% of students hitting their minimum weekly time goal</div>
                </div>
              </div>
            </wf-report-aggregate-panel>
          </div>
        </div>
        <div class="district-report-row">
          <div class="district-report-column width-100">
            <wf-report-aggregate-panel [cols]="teacherCols"
                                      [data]="teacherAggregateData()"
                                      [showTable]="showTeacherTable"
                                      (sortTableEvent)="sortTeacherTable($event)">
              <div class="engagement-table" header>
                <div class="title split-flex">
                  <div style="display: flex ; column-gap: 20px ; align-items: center ;">
                    <span>Teacher Engagement</span>
                    <span class="display-toggle print-hide" (click)="toggleTeacherTableSwitch()">{{ teacherTableSwitch }}</span>
                  </div>
                  <div class="dates-subtitle">Dates: {{ dateRange.startDisplay }} to {{ dateRange.endDisplay }}</div>
                </div>
                <div class="aggregate-stat-header-card teacher">
                  <div class="stat-title">{{ numTeachersMeetingStudentMinWeeklyTimeGoalThreshold() }} of {{ teacherAggregateData().length }} teachers</div>
                  <div class="stat-subtitle">had {{ studentPercentThresholdForMinWeeklyTimeGoal() }}% of students hitting the weekly time goal</div>
                </div>
              </div>
            </wf-report-aggregate-panel>
          </div>
        </div>
        <div class="district-report-row">
          <div class="district-report-column width-100">
            <div id="weeklyTimeGoal" class="district-report-panel">
              <div class="title split-flex">
                <div>Weekly Time Goal</div>
                <div class="dates-subtitle">Dates: {{ dateRange.startDisplay }} to {{ dateRange.endDisplay }}</div>
              </div>
              <div id="district-report-usage-goal">
                <div id="usage-info">
                  <div id="usage-goal-data" class="usage-row">
                    <wf-usage-goal-panel class="width-25" [minWeeklyTimeGoal]="60" [avgWeeklyUsage]="avgWeeklyUsage"></wf-usage-goal-panel>
                    <div id="usage-breakdown">
                      <div class="usage-donut-column">
                        <div id="usage-breakdown-chart-wrapper" class="print-hide">
                          <canvas baseChart
                                  #breakdownChart
                                  class="chart chart-doughnut"
                                  id="usage-breakdown-chart"
                                  aria-label="Distribution of student weekly usage"
                                  [data]="breakdownData"
                                  [type]="breakdownType"
                                  [options]="breakdownOpts"
                                  [plugins]="chartPlugins">
                          </canvas>
                        </div>
                        <img id="usage-breakdown-chart-img" class="chart-img" #breakdownChartImg />
                        <div class="donut-caption">Average Minutes / Week</div>
                      </div>

                      <div class="usage-mins-list">
                        <div class="heading">Student Minutes per week</div>
                        <div class="usage-mins-list-container">
                          <div class="usage-list">
                            <div class="highlight-row">
                              <div class="highlight-box">
                                <div class="usage-mins-row">
                                  <div class="usage-mins-percent">{{ breakdownPercentages[0] }}%</div>
                                  <div class="usage-mins-legend-block minutes-80-plus"></div>
                                  <div class="usage-mins-label">80+ minutes</div>
                                </div>
                                <div class="usage-mins-row">
                                  <div class="usage-mins-percent">{{ breakdownPercentages[1] }}%</div>
                                  <div class="usage-mins-legend-block minutes-60-79"></div>
                                  <div class="usage-mins-label">60-79 minutes</div>
                                </div>
                              </div>
                            </div>
                            <div class="usage-mins-row">
                              <div class="usage-mins-percent">{{ breakdownPercentages[2] }}%</div>
                              <div class="usage-mins-legend-block minutes-40-59"></div>
                              <div class="usage-mins-label">40 - 59 minutes</div>
                            </div>
                            <div class="usage-mins-row">
                              <div class="usage-mins-percent">{{ breakdownPercentages[3] }}%</div>
                              <div class="usage-mins-legend-block minutes-20-39"></div>
                              <div class="usage-mins-label">20 - 39 minutes</div>
                            </div>
                            <div class="usage-mins-row">
                              <div class="usage-mins-percent">{{ breakdownPercentages[4] }}%</div>
                              <div class="usage-mins-legend-block minutes-0-19"></div>
                              <div class="usage-mins-label">0 - 19 minutes</div>
                            </div>
                          </div>
                          <div class="highlight-summary">
                            <div class="highlight-percent">{{ studentsGetting60Plus }}%</div>
                            <div class="highlight-label">Students getting<br/>60 min or more</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </wf-district-report-container>
</div>
